<template>
  <div>
    <InstitutionDetail :id="$route.params.id"></InstitutionDetail>
  </div>
</template>

<script>
import InstitutionDetail from "@/components/InstitutionDetail.vue";

export default {
  name: "institution",
  components: {
    InstitutionDetail
  }
};
</script>
